const isGlobalMessageVisible = (response: { status: number; body: string;}) => {
    return response.status === 423
}

const isGlobalMessageRemovable = (response: { status: number; body: string;}) => {
    return response.body === 'true'
}

export default {
    isGlobalMessageVisible: isGlobalMessageVisible,
    isGlobalMessageRemovable: isGlobalMessageRemovable
  }
